import React from "react";
import { Lock, Shield } from "lucide-react";
import { useLang } from "@/lib/i18n";

/**
 * Privacy banner — used to show users that customer details are hidden.
 * variant: "customer" (your details stay private) | "merchant" (hidden until you win)
 */
export default function PrivacyBanner({ variant = "customer", className = "" }) {
  const { t } = useLang();
  if (variant === "merchant") {
    return (
      <div data-testid="privacy-banner-merchant" className={`rounded-2xl border border-zinc-200 bg-zinc-50 p-3.5 flex items-start gap-3 ${className}`}>
        <div className="h-9 w-9 rounded-full bg-white grid place-items-center shrink-0 shadow-sm">
          <Lock className="h-4 w-4 text-zinc-600" />
        </div>
        <div className="text-xs text-zinc-700 leading-relaxed">
          <div className="font-semibold text-zinc-900">{t("privacyMerchantTitle")}</div>
          {t("privacyMerchantBody")}
        </div>
      </div>
    );
  }
  return (
    <div data-testid="privacy-banner-customer" className={`rounded-2xl border border-emerald-200 bg-emerald-50/50 p-3.5 flex items-start gap-3 ${className}`}>
      <div className="h-9 w-9 rounded-full bg-white grid place-items-center shrink-0 shadow-sm">
        <Shield className="h-4 w-4 text-emerald-700" />
      </div>
      <div className="text-xs text-emerald-900 leading-relaxed">
        <div className="font-semibold">{t("privacyCustomerTitle")}</div>
        {t("privacyCustomerBody")}
      </div>
    </div>
  );
}
